<template>
    <div class="body-container">
        <BannerSection title="Préstamos en línea al instante sin checar buró"
                       subtitle="Rápido, seguro y sin dejar de usar tu auto" />
        <PerksComponent></PerksComponent>
        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <h1 class="title"><b>Préstamos en línea al instante sin checar buró</b></h1>
                    <p class="regular-text">
                        Imagina que necesitas dinero urgente, pero al solicitar un préstamo en el banco te lo niegan por
                        estar en Buró de Crédito. ¿Qué hacer en este caso? La buena noticia es que, si tienes un auto en
                        propiedad, estás en el lugar adecuado pues te vamos a presentar una opción en la que, aunque se
                        revisa el historial, el valor de tu auto tiene mayor peso y te permitirá obtener el dinero que
                        necesitas, en poco tiempo.
                    </p>
                    <p class="regular-text">
                        Aquí te explicamos cómo Ibancar puede ayudarte a conseguir un <b>préstamo en línea al instante
                            sin checar buró.</b>
                    </p>
                    <br>
                    <span>
                        <h2 class="h2-title"><b>¿Cómo obtener un Préstamo en Línea Sin Checar Buró?</b></h2>
                    </span>
                    <p class="regular-text">
                        Solicitar un préstamo con Ibancar es un proceso 100% en línea y sin complicaciones. A diferencia
                        de otros métodos, aquí se revisa el Buró de Crédito pero <b>lo importante es que el valor de tu
                            auto tiene mayor relevancia</b>, lo que significa que, sin importar tu historial, puedes
                        obtener el préstamo que estás buscando.
                    </p>
                    <h3 class="h3-title">
                        <b>Pasos para solicitarlo:</b>
                    </h3>
                    <ul>
                        <li>
                            <p class="regular-text"><b>Llena el formulario en línea:</b> Proporciona información sobre
                                tu auto y recibe una <b>preaprobación inmediata.</b></p>
                        </li>
                        <li>
                            <p class="regular-text"><b>Evaluación del vehículo:</b> Se toma en cuenta el modelo, año y
                                estado del mismo.</p>
                        </li>

                        <li>
                            <p class="regular-text"><b>Revisión técnica y firma del contrato:</b> Un profesional
                                verifica tu vehículo y recoge la factura.</p>
                        </li>
                        <li>
                            <p class="regular-text"><b>Recibe tu dinero en menos de 24 horas:</b> Una vez firmado el
                                contrato, el dinero se transfiere a tu cuenta.</p>
                        </li>
                    </ul>
                    <p class="regular-text">Así de fácil y rápido puedes acceder a <b>préstamos en línea sin checar buró
                            de crédito, al instante</b>, con Ibancar.</p>
                    <br>

                    <h2 class="h2-title"><b>Ventajas de solicitar un Préstamo con Ibancar</b></h2>

                    <p class="regular-text">A diferencia de otras opciones, en Ibancar te ofrecemos un servicio seguro,
                        sin requisitos innecesarios y con múltiples beneficios:
                    </p>

                    <h3 class="h3-title">
                        <b>Sin revisión de Buró de Crédito</b>
                    </h3>

                    <p class="regular-text">
                        No importa si tu historial crediticio no es el mejor, gracias a tu auto, puedes obtener un
                        préstamo en horas.
                    </p>

                    <h3 class="h3-title">
                        <b>Con una aprobación rápida y segura</b>
                    </h3>

                    <p class="regular-text">
                        Desde el primer paso hasta la aprobación, todo el proceso se realiza en horas y desde la
                        comodidad de tu casa.
                    </p>

                    <h3 class="h3-title">
                        <b>Recibirás tu dinero en 1 día</b>
                    </h3>

                    <p class="regular-text">
                        En cuanto se firme el contrato, realizamos la transferencia en <b>menos de 24 horas.</b>
                    </p>
                    <br>

                    <h2 class="h2-title"><b>Requisitos para acceder a tu Préstamo inmediato</b></h2>

                    <p class="regular-text">
                        Si tienes un auto, ya tienes acceso a un préstamo con Ibancar. Solo necesitas cumplir con estos
                        requisitos:
                    </p>

                    <ul>
                        <li>
                            <p class="regular-text">Contar con la <b>factura del vehículo </b>(de agencia o refactura).
                            </p>
                        </li>
                        <li>
                            <p class="regular-text">Ser mayor de edad y presentar tu <b>INE vigente</b>.</p>
                        </li>
                        <li>
                            <p class="regular-text">Proporcionar un comprobante de domicilio e ingresos.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>


        <div style="background-color: rgba(255, 165, 0, 0.04); padding: 1.5rem 0rem; margin: 0rem 0rem;">
            <div class="ibancar-election">
                <p>¿Por qué elegir Ibancar?</p>
            </div>
            <BeneficiosIbancarCarousel />
        </div>


        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <span class="bold-text">
                        <br>
                        <b>
                            <h2 class="h2-title">Preguntas frecuentes sobre los Préstamos en Línea sin Buró</h2>
                        </b>
                        <br>
                    </span>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Puedo solicitar un préstamo si ya tengo otro crédito?</p>
                        <p class="regular-text">Sí, en Ibancar aceptamos personas con otros créditos activos, mientras
                            el auto no tenga cargas o reserva de dominio, es decir, que no esté sujeto a ellas. De
                            hecho, nuestro préstamo puede ser utilizado para reunificar deudas</p>
                    </div>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Es necesario dejar mi auto como garantía?
                        </p>
                        <p class="regular-text">No, <b>sigues manejando tu auto</b> mientras pagas el préstamo.</p>
                    </div>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Cuánto dinero puedo obtener?</p>
                        <p class="regular-text">Dependiendo del modelo y estado del auto, puedes recibir desde
                            <b>$12,000 hasta $120,000 pesos.</b>
                        </p>
                    </div>
                    <br>
                    <p class="regular-text">Si estás buscando “<b>préstamos en línea al instante sin checar buró</b>”
                        Ibancar es la solución perfecta, si no quieres pasar por trámites ni revisiones complicados,
                        incluso estando en buró.</p>
                    <p class="regular-text">En solo <b>24 horas tendrás el dinero en tu cuenta</b>, sin perder el uso de
                        tu auto. ¡Solicita el tuyo ahora y resuelve tu situación financiera de inmediato!</p>
                </div>

            </div>

        </div>
        <SolicitaloBannerS2 />
    </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import BannerSection from '@/components/Landings/BannerSection.vue';
import BeneficiosIbancarCarousel from '@/components/PrestamoGarantiaAuto/BeneficiosIbancarCarousel.vue';
import SolicitaloBannerS2 from '@/components/Landings/SolicitaloBannerS2.vue';
import PerksComponent from '../components/PerksComponent.vue';


export default {
    name: 'PrestamoSinChecarBuro',
    components: {
        BannerSection,
        BeneficiosIbancarCarousel,
        SolicitaloBannerS2,
        PerksComponent
    },
    setup() {
        useMeta(
            {
                title: 'Préstamos en línea al instante sin checar buró | IBANCAR México',
                meta: [
                    {
                        name: 'robots',
                        content: 'index'
                    },
                    {
                        name: 'description',
                        content: 'Obtén préstamos en línea al instante sin checar buró. Sin trámites complicados y con aprobación rápida. Recibe tu dinero en 1 día con Ibancar. ¡Solicita ahora!'
                    },
                    {
                        name: 'keywords',
                        content: 'prestamos en linea al instante sin checar buro, préstamos en línea al instante sin checar buró, prestamos en linea sin checar buro de credito al instante'
                    }
                ],
                link: [
                    { href: 'https://ibancar.mx/prestamos-en-linea-confiables-sin-buro', rel: 'alternate', hreflang: 'es-MX' }
                ]
            }
        )
    },

    data() {
        return {
            ventajas: [
                {
                    image: 'image12.svg',
                    title: 'Ejecutivo personalizado',
                },
                {
                    image: 'solicitud-en-linea.svg',
                    title: 'Proceso simple sin salir de casa',
                },

                {
                    image: 'prestamos-48-hrs.svg',
                    title: 'Hasta $120,000 en 24H',
                },
                {
                    image: 'proceso-simple.svg',
                    title: 'Aceptamos personas en Buró.',
                }

            ]
        }
    }
}
</script>

<style scoped lang="scss">
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';


.image-container {
    text-align: center;
    margin: 3rem 0rem;

    img {
        max-height: 400px;
    }
}

.body-container {
    margin-top: 4.5rem;
    min-height: calc(100vh - 115px);
}

@include media-breakpoint-up(md) {
    .body-container {
        margin-top: 8.5rem;
    }
}

.ibancar-election {
    margin: 1rem 2rem 0rem 2rem;

    p {
        color: #004680;
        text-align: center;
        font-family: 'Montserrat-Bold';
        font-size: 1.3rem;
        font-style: normal;
        line-height: normal;
        margin: 1.5rem 0rem;
    }
}

.text-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    text-align: justify;
}

.regular-text {
    font-family: "Montserrat";
    font-size: 20px;
    line-height: 30px;
}

.bold-text {
    font-family: "Montserrat-Bold";
}

.text-orange {
    color: $orange;
}

.text-blue {
    color: $blue;
}

.text-black {
    color: $black;
}

.text-underline {
    text-decoration: underline;
}


.btn-solicitar {
    a {
        &:hover {
            text-decoration: none;
        }
    }
}

// Image
.image {
    bottom: 0;
    right: 0;
    width: 30%;
    z-index: -1;
}

@include media-breakpoint-down(md) {
    .text-container {
        width: 90%;
    }

    .regular-text {
        line-height: 1.5;
    }

    ul {
        padding-inline-start: 20px;
    }

    ol {
        padding-inline-start: 20px;
    }

    p,
    h1,
    h2,
    h3,
    h4 {
        text-align: left;
    }
}

@include media-breakpoint-between(md, lg) {
    .regular-text {
        font-size: 16px;
    }

    .subtitle {
        font-size: 16px;
    }
}

@include media-breakpoint-down(sm) {
    .title {
        font-size: 23px;
        line-height: 25px;
    }

    .h2-title {
        font-size: 18px;
        line-height: 20px;
    }

    .h3-title {
        font-size: 16px;
        line-height: 15px;
    }

    .regular-text {
        font-size: 14px !important;
    }

    .section-container {
        margin-top: 1.5rem;
    }
}
</style>